import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

import axios from "axios";
import {
  FormContainer,
  StyledInput,
  Label,
  ErrorLabel,
  FindContainer,
} from "./styles";
import Button from "../Button/Button";

const Form = ({
  nftId,
  setNftID,
  NftData,
  setNftData,
  hideNFTview,
  setHideNFTview,
  loading,
  setLoading,
}) => {
  let navigate = useNavigate();
  const [error, setError] = useState(undefined);
  const handleFormChange = (e) => {
    setNftID(e.target.value);
  };
  const handleButtonClick = async (e) => {
    const api_url = `${process.env.REACT_APP_API_URL}/v1/score/each`;
    nftId = parseInt(nftId);
    if (typeof nftId === "number" && !isNaN(nftId)) {
      setLoading(true);
      try {
        const response = await axios.get(`${api_url}/${nftId}`);
        await setNftData(response.data.data);
        setLoading(false);
        navigate("/profile/" + nftId, { data: NftData });
      } catch (e) {
        setLoading(false);
        setHideNFTview(true);
      }
    } else {
      console.log("errpr", error);
      setError("Please Enter number");
      setTimeout(() => {
        setError(undefined);
      }, 4000);
    }
  };

  return (
    <FormContainer>
      {/* <Label>Enter Your NFT ID</Label> */}
      <StyledInput
        type="text"
        placeholder="Enter your NFT ID here"
        onChange={handleFormChange}
      />

      <Find handleButtonClick={handleButtonClick} />
      {loading && (
        <Label style={{ color: "red", fontSize: "1.1rem" }}>
          Loading, Pleas Wait....
        </Label>
      )}
      {error && <Label style={{ color: "red" }}>{error}</Label>}
      {/* {!nftId && <ErrorLabel>NFT ID required.</ErrorLabel>} */}
      {/* <Button onClick={handleButtonClick} /> */}
    </FormContainer>
  );
};
const Find = ({ handleButtonClick }) => {
  return (
    <FindContainer onClick={() => handleButtonClick()}>
      <FaSearch
        style={{ color: "#fff", marginRight: "0.7rem", fontSize: "1rem" }}
      />
      <span>Find</span>
    </FindContainer>
  );
};
export default Form;
